document.querySelectorAll('.offer-copy-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    navigator.clipboard.writeText(btn.dataset.copy).then(() => {
      btn.innerHTML = 'Copied!';
      btn.style.color = '#4caf50';
      setTimeout(() => {
        btn.style.color = '';
        btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>`;
      }, 1500);
    });
  });
});

class PdpUrgencyTimer extends HTMLElement {
  connectedCallback() {
    const expiresAt = this.getExpirationTime();

    if (!expiresAt) {
      return;
    }

    this.tick(expiresAt);
    this.interval = window.setInterval(() => this.tick(expiresAt), 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

    getExpirationTime() {
    if (this.dataset.timerMode === 'fixed_date' && this.dataset.expiresAt) {
      const expiresAt = this.dataset.expiresAt.trim();
      const normalized = expiresAt.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
      const fixedDate = Date.parse(normalized);

      return Number.isNaN(fixedDate) ? null : fixedDate;
    }

    const durationMinutes = parseInt(this.dataset.durationMinutes, 10) || 30;
    const storageKey = this.dataset.storageKey;

    if (!storageKey) {
      return Date.now() + durationMinutes * 60 * 1000;
    }

    try {
      const stored = sessionStorage.getItem(storageKey);

      if (stored) {
        return parseInt(stored, 10);
      }

      const expiresAt = Date.now() + durationMinutes * 60 * 1000;
      sessionStorage.setItem(storageKey, expiresAt.toString());
      return expiresAt;
    } catch (error) {
      return Date.now() + durationMinutes * 60 * 1000;
    }
  }

  tick(expiresAt) {
    const remaining = expiresAt - Date.now();
    const wrapper = this.closest('.slovic-pdp-urgency-timer');

    if (remaining <= 0) {
      clearInterval(this.interval);

      if (this.dataset.expirationBehavior === 'hide') {
        wrapper?.remove();
        return;
      }

      wrapper?.classList.add('is-expired');

      if (wrapper && this.dataset.expiredMessage && !wrapper.querySelector('.slovic-pdp-urgency-timer__expired')) {
        const expiredMessage = document.createElement('p');
        expiredMessage.className = 'slovic-pdp-urgency-timer__expired';
        expiredMessage.textContent = this.dataset.expiredMessage;
        wrapper.querySelector('.slovic-pdp-urgency-timer__content')?.appendChild(expiredMessage);
      }

      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.updateUnit('hours', hours);
    this.updateUnit('minutes', minutes);
    this.updateUnit('seconds', seconds);

    const label = `${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`;
    this.setAttribute('aria-label', label);
  }

  updateUnit(unit, value) {
    const element = this.querySelector(`[data-unit="${unit}"]`);

    if (element) {
      element.textContent = String(value).padStart(2, '0');
    }
  }
}

if (!window.customElements.get('pdp-urgency-timer')) {
  window.customElements.define('pdp-urgency-timer', PdpUrgencyTimer);
}
